import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button, Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import { updateTanClientCredentials } from "api/services/automation/income-tax-tan";
import DrawerWrapper from "components/DrawerWrapper";
import Loader from "components/Loader";
import SafeTextField from "components/SafeTextField";
import { snack } from "components/toast";
import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { TRACE_PASSWORD_REGEX, TRACE_USER_ID_REGEX } from "validations/regexPattrens";

const CredentialsEdit = ({ open, setOpen, data }) => {
  const queryClient = useQueryClient();
  const [state, setState] = useState(data);

  const [tanPasswordVisibility,setTanPasswordVisibility] = useState(false);
  const [tracePasswordVisibility,setTracePasswordVisibility] = useState(false);

  const handleTraceTogglePassword = () => {
    setTracePasswordVisibility(!tracePasswordVisibility);
  };

  const handleTanTogglePassword = () => {
    setTanPasswordVisibility(!tanPasswordVisibility);
  };

  useEffect(() => {
    setState(data);
  }, [data]);

  useEffect(()=>{
    setTracePasswordVisibility(false);
    setTanPasswordVisibility(false);
  },[open])

  const handleChange = (e: any) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const { mutate, isLoading } = useMutation(updateTanClientCredentials, {
    onSuccess: (res) => {
      snack.success("Client Income Tax TAN Creadentials Updated");
      setTimeout(() => {
        queryClient.invalidateQueries("get-tan-Clients-Credentials");
      }, 500);
      setOpen(false);
    },
    onError: (err: any) => {
      if (err && err?.response && err?.response?.data && err?.response?.data?.message) {
        snack.error(err.response.data.message);
      } else if (!err.error) {
        snack.error("An error occurred while updating Client Income Tax Tan Creadentials");
      }
    },
  });

  const isValidTraceUserId = (traceUserId) => {
    return TRACE_USER_ID_REGEX.test(traceUserId);
  };
  const isValidTracePassword = (tracePassword) => {
    return TRACE_PASSWORD_REGEX.test(tracePassword);
  };

  const handleChangePassword = () => {
    mutate({
      id: state.id,
      data: state,
    });
  };

  if (isLoading) return <Loader />;
  return (
    <DrawerWrapper title="Income Tax TAN Password Edit" open={open} setOpen={setOpen}>
      <Grid container spacing={2}>
        <Grid item xs={12} mt={2}>
          <TextField
            fullWidth
            size="small"
            label="Client Category"
            disabled={true}
            name=""
            value={state?.client?.category || ""}
            inputProps={{ maxLength: 100 }}
            required
          />
        </Grid>
        <Grid item xs={12} mt={2}>
          <SafeTextField
            fullWidth
            size="small"
            label="Client Name"
            disabled={true}
            name=""
            value={state?.client?.displayName || ""}
            inputProps={{ maxLength: 100 }}
            required
          />
        </Grid>
        <Grid item xs={12} mt={1}>
          <TextField
            // onChange={handleChange}
            size="small"
            fullWidth
            disabled={true}
            label="TAN"
            name="tanNumber"
            value={state?.tanNumber || ""}
            inputProps={{ maxLength: 100 }}
          />
        </Grid>

        <Grid item xs={12} mt={1}>
          <TextField
            onChange={handleChange}
            fullWidth
            size="small"
            label="Password"
            name="password"
            value={state?.password || ""}
            inputProps={{ maxLength: 50 }}
            // required
             type={tanPasswordVisibility ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTanTogglePassword} edge="end">
                    {tanPasswordVisibility ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} mt={1}>
          <TextField
            variant="outlined"
            fullWidth
            size="small"
            label="Trace User Id"
            name="traceUserId"
            onChange={handleChange}
            value={state?.traceUserId || ""}
            inputProps={{ maxLength: 50 }}
            error={
              !isValidTraceUserId(state?.traceUserId) &&
              state?.traceUserId !== "" &&
              state?.traceUserId !== null
            }
            helperText={
              !isValidTraceUserId(state?.traceUserId) &&
              state?.traceUserId !== "" &&
              state?.traceUserId !== null &&
              "Invalid Trace User ID Pattern"
            }
          />
        </Grid>

        <Grid item xs={12} mt={1}>
          <TextField
            fullWidth
            size="small"
            label="Trace Password"
            name="tracePassword"
            onChange={handleChange}
            variant="outlined"
            value={state?.tracePassword || ""}
            inputProps={{ maxLength: 50 }}
            error={
              !isValidTracePassword(state?.tracePassword) &&
              state?.tracePassword !== "" &&
              state?.tracePassword !== null
            }
            helperText={
              !isValidTracePassword(state?.tracePassword) &&
              state?.tracePassword !== "" &&
              state?.tracePassword !== null &&
              "Invalid Trace Password Pattern"
            }
             type={tracePasswordVisibility ? "text" : "password"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={handleTraceTogglePassword} edge="end">
                                {tracePasswordVisibility ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
          />
        </Grid>

        <Grid item xs={12}>
          <Button onClick={handleChangePassword} fullWidth color="secondary" variant="contained">
            Update
          </Button>
        </Grid>
      </Grid>
    </DrawerWrapper>
  );
};

export default CredentialsEdit;
